import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";

export const SaveHeroSection = ({
  imageUrl,
  content,
  anchorAction,
  reverse = false
}) => {
  const { title, description } = content;
  const { text, route } = anchorAction;
  const directionClassName = reverse ? "ltr" : "rtl";

  return (
    <section
      className={`save-hero-section-container ${directionClassName}`}
      data-testid="save-hero-section"
    >
      <div className="save-hero-image-wrapper">
        <img src={imageUrl} alt={title} className="save-hero-image" />
      </div>
      <div className="save-hero-body">
        <h2 className="save-hero-title">{title}</h2>
        <p className="save-hero-description">{description}</p>
        <NavLink className="save-hero-anchor" to={route}>
          {text}
        </NavLink>
      </div>
    </section>
  );
};
